<div class="Ang-dashboard-container" >
    <app-dashboard-filter (emitApplyFilter)="applyFilter($event)" (emitResetFilter)="resetFilter()" [title]="'Dashboard'" ></app-dashboard-filter>
    <div>
        <!-- <bi-app id="biApp" [pageDefinition]="pageDefinition" [baseUrl]="baseURL"  ></bi-app> -->
        <bi-app id="biApp" [pageDefinition]="pageDefinition" [baseUrl]="baseURL" [authDefinition]="authObject" ></bi-app>

    </div>
</div>
<!-- <bi-app id="biApp" [pageDefinition]="pageDefinition" [baseUrl]="baseURL" [authDefinition]="authObject" ></bi-app> -->
